import React from 'react';
import { Icons } from '../../../components/atoms/SVG';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  DISPLAY_TYPE,
  createButtonObject,
} from '../../../components/organisms/BlockInteractions';
import { BlockType } from '../../../types/api/ElementType';
import { Namespace } from '../../../translation/namespace';
import { DefaultView, OptionalEditView, Views } from '../../../types/BlockWithViews';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { ThreadListEditDefaultView } from '../views/ThreadListEditDefaultView';
import { ThreadListEditView } from '../views/ThreadListEditView';

export type ThreadListBlockProps = Views<DefaultView<any> & OptionalEditView<ThreadListEditView>>;

export function ThreadListInteractions({ views, activeView }: ThreadListBlockProps) {
  const { t } = useSonTranslation('ThreadlistBlock');
  const { uuid } = useBlockContext();
  const buttons = views.edit
    ? createButtonObject(
        BlockInteractionsViews.EDIT,
        Icons.EDIT_PENCIL,
        `${Namespace.ThreadlistBlock}:edit`,
        DISPLAY_TYPE.COLLAPSIBLE,
        <ThreadListEditView {...views.edit} />
      )
    : {};

  return (
    <BlockInteractions
      uuid={uuid}
      elementType={BlockType.calendar}
      headline={{
        text: t('title'),
        hierarchy: 3,
        visible: true,
      }}
      activeView={activeView}
      views={views}
      buttons={buttons}
    >
      <ThreadListEditDefaultView {...views.default} />
    </BlockInteractions>
  );
}
